// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__13xiE","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__UxL5l"};